// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let Redirect = require("../../reason/common/Redirect.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let OptionExt = require("../common/OptionExt.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let FormalityUI = require("../common/Components/FormalityUI.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql = require("../../__generated__/UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.bs.js");
let UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql = require("../../__generated__/UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql.bs.js");

let convertVariables = UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedTeamAccountProfileBasicInfoSettingsBasicInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let BasicInfoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useBasicInfo() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedTeamBasicInfo;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let website = param.website;
    if (website === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let website$1 = Scalars.URL.fromString(website);
    if (website$1.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(website$1._0)
      };
    } else {
      return {
        TAG: "Error",
        _0: "InvalidUrl"
      };
    }
  }
};

let validators_brokerage = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: OptionExt.ofString(param.brokerage)
  })
};

let validators_teamName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let teamName = param.teamName.trim();
    if (teamName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: teamName
      };
    }
  }
};

let validators = {
  website: validators_website,
  brokerage: validators_brokerage,
  teamName: validators_teamName
};

function initialFieldsStatuses(input) {
  return {
    website: "Pristine",
    brokerage: "Pristine",
    teamName: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    website: "Pristine",
    brokerage: "Pristine",
    teamName: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      website: "Pristine",
      brokerage: "Pristine",
      teamName: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.website;
  let tmp;
  tmp = typeof match !== "object" ? validators.website.validate(input) : match._0;
  let match$1 = fieldsStatuses.brokerage;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.brokerage.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.teamName;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.teamName.validate(input) : match$2._0;
  let websiteResult = tmp;
  let websiteResult$1;
  if (websiteResult.TAG === "Ok") {
    let brokerageResult = tmp$1;
    if (brokerageResult.TAG === "Ok") {
      let teamNameResult = tmp$2;
      if (teamNameResult.TAG === "Ok") {
        return {
          TAG: "Valid",
          output: {
            teamName: teamNameResult._0,
            brokerage: brokerageResult._0,
            website: websiteResult._0
          },
          fieldsStatuses: {
            website: {
              TAG: "Dirty",
              _0: websiteResult,
              _1: "Shown"
            },
            brokerage: {
              TAG: "Dirty",
              _0: brokerageResult,
              _1: "Shown"
            },
            teamName: {
              TAG: "Dirty",
              _0: teamNameResult,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
      }
      websiteResult$1 = websiteResult;
    } else {
      websiteResult$1 = websiteResult;
    }
  } else {
    websiteResult$1 = websiteResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      website: {
        TAG: "Dirty",
        _0: websiteResult$1,
        _1: "Shown"
      },
      brokerage: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      teamName: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurWebsiteField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.website, validators_website, status => {
            let init = state.fieldsStatuses;
            return {
              website: status,
              brokerage: init.brokerage,
              teamName: init.teamName
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBrokerageField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brokerage, validators_brokerage, status => {
            let init = state.fieldsStatuses;
            return {
              website: init.website,
              brokerage: status,
              teamName: init.teamName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTeamNameField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamName, validators_teamName, status => {
            let init = state.fieldsStatuses;
            return {
              website: init.website,
              brokerage: init.brokerage,
              teamName: status
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateWebsiteField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.website, state.submissionStatus, validators_website, status => {
                let init = state.fieldsStatuses;
                return {
                  website: status,
                  brokerage: init.brokerage,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBrokerageField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.brokerage, state.submissionStatus, validators_brokerage, status => {
                let init = state.fieldsStatuses;
                return {
                  website: init.website,
                  brokerage: status,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTeamNameField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.teamName, state.submissionStatus, validators_teamName, status => {
                let init = state.fieldsStatuses;
                return {
                  website: init.website,
                  brokerage: init.brokerage,
                  teamName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  website: "Pristine",
                  brokerage: "Pristine",
                  teamName: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  website: "Pristine",
                  brokerage: "Pristine",
                  teamName: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateWebsite: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateWebsiteField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBrokerage: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBrokerageField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTeamName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTeamNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurWebsite: () => dispatch("BlurWebsiteField"),
    blurBrokerage: () => dispatch("BlurBrokerageField"),
    blurTeamName: () => dispatch("BlurTeamNameField"),
    websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
    brokerageResult: Formality.exposeFieldResult(state.fieldsStatuses.brokerage),
    teamNameResult: Formality.exposeFieldResult(state.fieldsStatuses.teamName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.website;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.brokerage;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.teamName;
      return typeof tmp$2 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function messageToString(message) {
  if (message === "IsRequired") {
    return "is required";
  } else {
    return "must be a valid URL";
  }
}

function UnifiedTeamAccountProfileBasicInfoSettings$InputField(props) {
  let result = props.result;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.label
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(result),
            value: props.value
          }),
          JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
            messageToString: messageToString,
            result: result
          })
        ],
        className: "mt-2 space-y-3 sm:col-span-2 sm:mt-0 sm:max-w-xs"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  messageToString: messageToString,
  make: UnifiedTeamAccountProfileBasicInfoSettings$InputField
};

let convertVariables$1 = UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UnifiedTeamAccountProfileBasicInfoSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedTeamAccountProfileBasicInfoSettings(props) {
  let match = use$1(undefined, undefined, undefined, undefined);
  let profile = match.currentAccountV5.profile;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/account_profile"
      });
    case "TeamAccountProfile" :
      let match$1 = useBasicInfo();
      let save = match$1[0];
      let form = useForm({
        teamName: profile.teamName,
        brokerage: Stdlib_Option.getOr(profile.brokerage, ""),
        website: Stdlib_Option.getOr(Stdlib_Option.map(profile.website, Scalars.URL.toString), "")
      }, (values, param) => {
        let notifyOnFailure = param.notifyOnFailure;
        let notifyOnSuccess = param.notifyOnSuccess;
        save({
          brokerage: Stdlib_Option.getOr(values.brokerage, ""),
          teamName: values.teamName,
          website: Stdlib_Option.getOr(Stdlib_Option.map(values.website, Scalars.URL.toString), "")
        }, () => notifyOnSuccess(undefined), param => notifyOnFailure());
      });
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
            title: "Basic Information",
            rootName: "Your Team's Profile",
            rootUrl: "/account/account_profile",
            url: "/account/account_profile/basic_info"
          }),
          JsxRuntime.jsxs("form", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(UnifiedTeamAccountProfileBasicInfoSettings$InputField, {
                    label: "Team name",
                    value: form.input.teamName,
                    onChange: event => form.updateTeamName((input, value) => ({
                      teamName: value,
                      brokerage: input.brokerage,
                      website: input.website
                    }), event.target.value),
                    onBlur: param => form.blurTeamName(),
                    result: form.teamNameResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileBasicInfoSettings$InputField, {
                    label: "Brokerage",
                    value: form.input.brokerage,
                    onChange: event => form.updateBrokerage((input, value) => ({
                      teamName: input.teamName,
                      brokerage: value,
                      website: input.website
                    }), event.target.value),
                    onBlur: param => form.blurBrokerage(),
                    result: form.brokerageResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileBasicInfoSettings$InputField, {
                    label: "Website",
                    value: form.input.website,
                    onChange: event => form.updateWebsite((input, value) => ({
                      teamName: input.teamName,
                      brokerage: input.brokerage,
                      website: value
                    }), event.target.value),
                    onBlur: param => form.blurWebsite(),
                    result: form.websiteResult
                  })
                ],
                className: "space-y-8 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
              }),
              JsxRuntime.jsx(UnifiedProfileSettingsUI.FormActions.make, {
                publicUrl: profile.publicUrl,
                saveDisabled: match$1[1] || form.submitting
              }),
              match$1[2]
            ],
            className: "space-y-6",
            onSubmit: event => {
              event.preventDefault();
              form.submit();
            }
          })
        ],
        className: "space-y-8 rounded bg-white p-6 shadow-sm"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
  }
}

let make = UnifiedTeamAccountProfileBasicInfoSettings;

exports.BasicInfoMutation = BasicInfoMutation;
exports.useBasicInfo = useBasicInfo;
exports.FormConfig = FormConfig;
exports.InputField = InputField;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
